const ru = {
    demo: {
        title: `Английский`,
        introduction: `Lorem Ipsum`,
    },
    docs: {
        hi: `Привет`,
        description: `Нужна помощь? \n Пожалуйста, проверьте нашу документацию.`,
        documentation: `документация`,
    },
    yes: `Да`,
    no: `Нет`,
    home: `Главная`,
    dashboard: `Панель управления`,
    user: `Пользователь`,
    account: `Аккаунт`,
    general: `Общее`,
    settings: `Настройки`,
    username: `Имя пользователя`,
    login: `Войти`,
    logout: `Выйти`,
    emailAddress: `Адрес электронной почты`,
    password: `Пароль`,
    newPassword: `Новый пароль`,
    oldPassword: `Старый пароль`,
    confirmNewPassword: `Подтвердите новый пароль`,
    updatePassword: `Обновить пароль`,
    formErrorValidEmail: `Электронная почта должна быть действительным адресом электронной почты`,
    formErrorEmailRequired: `Электронная почта требуется`,
    formErrorPasswordRequired: `Пароль требуется`,
    formErrorOldPasswordRequired: `Старый пароль требуется`,
    formErrorPasswordLength: `Пароль должен содержать не менее 6 символов`,
    formErrorConfirmPasswordRequired: `Подтверждение пароля требуется`,
    formErrorPasswordsMatch: `Пароли должны совпадать`,
    formForgotPasswordLink: `Забыли пароль?`,
    snackBarChangePasswordSuccess: `Смена пароля прошла успешно!`,
    snackBarUpdateSuccess: `Обновление прошло успешно!`,
    active: `Активный`,
    inactive: `Неактивный`,
    on: `Вкл`,
    off: `Выкл`,
    billing: `Биллинг`,
    description: `Описание`,
    amount: `Сумма`,
    status: `Статус`,
    changePassword: `Изменить пароль`,
    changeSettings: `Изменить настройки`,
    setup: `Настройка`,
    free: `Бесплатно`,
    invoices: `Счета`,
    cancelSubscriptionButton: `Отменить подписку`,
    date: 'Дата',
    download: 'Скачать',
    print: 'Печать',
    close: 'Закрыть',
    view: 'Просмотр',
    DataOwl: `Data Owl`,
    DataOwlTip: `Data Owl сканирует скрытые источники в интернете, чтобы определить, появлялся ли ваш email в утечках данных, и помогает оставаться в безопасности благодаря своевременным уведомлениям.`,
    warningBanner: {
        text: 'У вас нет активной учетной записи. Чтобы активировать учетную запись, обновите ее, нажав кнопку.',
        ctaButton: 'Обновить',
        caption: 'Подпись'
    },
    loginPage: {
        title: `Войти`,
        formTitle: `Новичок в Anomica? Создать аккаунт`,
        formTitleLink: `здесь`,
        formForgotPasswordLink: `Забыли пароль?`
    },
    resetPasswordPage: {
        title: `Сброс пароля`,
        formTitle: `Забыли пароль?`,
        formSubTitle: ` Пожалуйста, введите адрес электронной почты, связанный с вашей учетной записью, и мы отправим вам ссылку для сброса пароля по электронной почте.`,
        formTitleLink: `Вернуться к входу`,
        formButton: `Отправить запрос`,
    },
    newPasswordPage: {
        title: `Сброс пароля`,
        formTitle: `Запрос успешно отправлен!`,
        formSubTitle: `Мы отправили электронное письмо со ссылкой подтверждения.`,
        formSubTitle2: `Пожалуйста, посетите ссылку, чтобы подтвердить вашу электронную почту.`,
        formTitleLink: `Вернуться к входу`,
        formButton: `Отправить запрос`,
    },
    accountPage: {
        title: `Аккаунт`,
        accountStatus: `Статус аккаунта`,
        accountType: `Тип аккаунта`,
        renewAccount: `Обновить аккаунт`,
        endDate: `Дата окончания`,
        subRemaining: `Оставшаяся подписка:`,
        autoRenew: `Автоматическое обновление`,
        vpnCredentials: `Учетные данные VPN:`,
        setupVpn: `Настроить VPN`,
        nextBillingDate: `Следующая дата биллинга`,
        endOfFreeTerm: `Конец бесплатного периода`,
        cancelSubscription: `Отменить подписку`,
        activationCode: `Код активации`,
        newsNotifications: `Электронные письма с новостями и уведомлениями`,
        darkWebMonitoring: `Щит Dark Web`,
        setupMonitoring: `Настроить мониторинг`,
        recurringSubscription: `Повторяющаяся подписка`,
        getSubscription: 'Получить подписку',
        nextBillingDateWarning: 'Точная дата списания может варьироваться и зависит от метода оплаты.',
        tabs: {
            general: `Общее`,
            settings: `Настройки`,
            changePassword: `Изменить пароль`
        },
    },
    settingsPage: {
        title: `Настройки`,
        formTitle: `УВЕДОМЛЕНИЯ И РАССЫЛКИ`,
        recurringPayment: ` Повторяющийся платеж`,
        yourSubscription: `Ваша подписка`,
        per: `За`,
        curSubs: `Текущая подписка будет продолжаться до`,
        warn: `Ваш аккаунт больше не будет продлеваться ежемесячно.`,
        submitButton: `Сохранить изменения`,
        settingsOption1: `Новости и объявления`
    },
    setupVpnPage: {
        title: `Настроить VPN`,
        header: `Скачать Anomica для {{os}}`,
        coverH1: `Скачайте приложение одним нажатием кнопки`,
        coverH2: `Вам нужно только скачать, все заполнено для вас`,
        coverH3: `Также доступно для`,
        coverButtonText: 'Скачать для ',
        setupBadge: `НАСТРОЙКА ANOMICA`,
        preferManual: `Предпочитаете установить вручную? Ознакомьтесь с шагами ниже.`,
        installManuallyLink: `Установить вручную`,
        footerText: `Если у вас остались вопросы, свяжитесь с нами по адресу`,
        tabH1: `Код активации уже заполнен для вас, и вам нужно только скачать Anomica.`,
        tabH2: `Предпочитаете установить вручную?`,
        step1: ` Скачать`,
        step1Caption: `Код активации уже заполнен для вас, и вам нужно только скачать Anomica. Предпочитаете установить вручную?`,
        step2: ` Копировать`,
        step2Caption: `Скопируйте код активации и используйте его во время настройки программного обеспечения.`,
        step3: ` Вставить`,
        step3Caption: `Вставьте скопированный код активации в программное обеспечение, чтобы завершить установку Anomica.`,
        manual: {
          disabledTooltip: `Доступно только для авторизованных пользователей с активной подпиской.`,
          authRequired: `Пожалуйста, войдите, чтобы продолжить.`,
          step1: `Выберите сервер`,
          step1Caption: `Выберите страну и сервер для подключения.`,
          country: `Страна`,
          server: `Сервер`,
          protocol: `Протокол`,
          step2: `Скачать файл конфигурации`,
          step2Caption: `Скачайте файл конфигурации .ovpn для выбранного сервера.`,
          downloadButton: `Скачать .ovpn`,
          step3: `Подключиться`,
          step3Caption: `Откройте клиент OpenVPN, импортируйте скачанный файл и подключитесь. Используйте VPN Логин и VPN Пароль, указанные ниже.`,
        },
    },
    promoPage: {

        tabH1: `Поздравляем и добро пожаловать!. Ваш лимит трафика обновлен. Наслаждайтесь 5 ГБ ежемесячного использования. `,
        tabH2: `Вам нужно только скачать, все заполнено для вас`,
    },
    cancelSubscription: {
        h1: `Если вы хотите отменить подписку, `,
        h1br:`вы можете сделать это легко ниже.`,
        sub1: `Мы рады, что вы были членом. Вы всегда можете вернуться.`,
        sub1br: `Вы можете завершить отмену ниже.`,
        cardTitle: `Отменить подписку`,
        cardText: `Вы уверены, что хотите отказаться от своей онлайн-приватности? Тогда используйте кнопку ниже, чтобы завершить отмену подписки.`,
        cancelButton: `Завершить отмену`,
        backButton: `Вернуться на сайт`,
        cardCaption: `Отмена вступит в силу в конце текущего периода биллинга`,
        cardCaptionBr: `в`,
        h2: `Почему остаться с Anomica?`,
        p1: `100% Приватность`,
        p1c: `С Anomica все заботы о вашей онлайн-приватности в прошлом. Никто не может просматривать ваши данные, и вы можете свободно перемещаться в интернете.`,
        p2: `100% Безопасность`,
        p2c: `Поскольку VPN шифрует ваше соединение, хакеры больше не могут взломать. Это предотвратит их от кражи ваших данных.`,
        p3: `100% Свобода`,
        p3c: `С Anomica вы можете обходить геоблоки и притворяться, что находитесь в другой стране, чтобы наслаждаться 100% онлайн-свободой.`,
        p4: `100% Стриминг`,
        p4c: `С Anomica вы получаете доступ к каждому (иностранному) сервису стриминга. Дополнительное преимущество: Наши сверхбыстрые соединения идеальны для стриминга!`,
        p5: `100% Загрузка`,
        p5c: `С сверхбыстрыми серверами и современными протоколами VPN Нидерланды вы можете без усилий загружать и транслировать в любом месте мира.`,
        exButton: `Оставаться в безопасности онлайн`,
        h1Canceled: `Вы успешно отменили подписку.`,
        h1CanceledFree: `Вы успешно отменили подписку.`,
        sub1Canceled: `Спасибо, что были членом, возвращайтесь в любое время!`,
        sure: `Вы уверены?`,
        happy: `Мы будем рады видеть вас снова в любое время.`
    },
    verifyEmailPage: {
        title: ``,
        checkYourEmail: `Пожалуйста, проверьте вашу электронную почту!`,
        inProgress: `Верификация в процессе...`,
        bottomText: `Вся информация о вашей подписке и приложении находится в вашем почтовом ящике.`,
        success: `Электронная почта верифицирована!`,
        alreadyVerified: 'Электронная почта уже верифицирована!',
        button: `Просмотреть ваш аккаунт`,
        p1: `Вы выбрали VPN Нидерланды`,
        p2: `Вы успешно зарегистрировались`,
        p3: `Ваш адрес электронной почты успешно верифицирован`,
        p4: `Ваша подписка на Anomica активирована.`,
    },
    billingPage: {

        paymentFor: `Оплата за`,
        invoiceNumber: `ID счета`,
    },
    monitoringPage: {
      title: `Data Owl`,
      setUpMonitoring: `Настроить мониторинг`,
      featureActivatedAlert: `Data Owl активирован`,
      featureNotActivatedAlert: `Data Owl в данный момент не активирован`,
      notifyToggleLabel: `Уведомлять меня при обнаружении новой утечки данных`,
      consentDisclaimer: `Включая эту функцию, вы соглашаетесь с тем, что мы передадим ваш адрес электронной почты безопасным службам сканирования для проверки на утечки данных. Вы получите уведомление по электронной почте при обнаружении новых утечек.`,
      breachesDetectedTitle: `Обнаружены утечки данных`,
      breachesFoundWarning: `О нет! Мы нашли <0>{{number}} {{breachWord}}</0>, включая утёкшие пароли. Прочитайте <1>нашу статью</1>, чтобы узнать, как защитить себя от будущих утечек.`,
      breach_one: `утечку данных`,
      breach_other: `утечек данных`,
      btnUpdating: `Обновление...`,
      btnSaveAndScan: `Сохранить изменения и сканировать сейчас`,
      btnSave: `Сохранить изменения`,
      btnAddedToQueue: `Добавлено в очередь...`,
      btnDataRetrieved: `Данные получены`,
      compromisedData: `Утёкшие данные:`,
      dataOwl: {
        faq: {
          what_does_it_do: {
            heading: `Что делает эта функция?`,
            detail: `Инструмент Data Owl непрерывно сканирует Dark Web и известные базы утечек на наличие адресов электронной почты, которые вы выбрали для мониторинга. Если ваши данные обнаружены в утечке, вы мгновенно получите уведомление с подробной информацией об источнике и дате утечки, о том, какие данные были раскрыты, и другую важную информацию. Вы также получите понятные инструкции по защите своих аккаунтов.`,
          },
          how_does_it_work: {
            heading: `Как этот инструмент помогает мне защититься?`,
            detail: `Утечки данных и нарушения безопасности происходят ежедневно и представляют серьёзную угрозу вашей онлайн-безопасности. Как только ваши данные утекают, они могут быть немедленно использованы для всевозможных кибератак — от фишинга и онлайн-мошенничества до угона аккаунтов и финансовых афер. Data Owl от Anomica помогает вам быть на шаг впереди, мгновенно уведомляя о произошедшей утечке, предоставляя подробные отчёты и предлагая профессиональные рекомендации для решения любой ситуации.`,
          },
          does_it_solve_anything: {
            heading: `Эта функция бесплатна?`,
            detail: `Инструмент Data Owl включён в каждую подписку Anomica без дополнительной платы. Он предлагает круглосуточный мониторинг, неограниченное отслеживание email-адресов, детальные отчёты об утечках и индивидуальные рекомендации, которые помогут вам реагировать на любой инцидент.`,
          },
        },
      },
      dataClasses: {
        "Email addresses": `Адреса электронной почты`,
        Passwords: `Пароли`,
        Usernames: `Имена пользователей`,
        "IP addresses": `IP-адреса`,
        "Physical addresses": `Физические адреса`,
        "Phone numbers": `Номера телефонов`,
        Names: `Имена`,
        "Job titles": `Должности`,
        "Dates of birth": `Даты рождения`,
        "Financial data": `Финансовые данные`,
        "Credit cards": `Кредитные карты`,
        "Bank account numbers": `Номера банковских счетов`,
        "Social security numbers": `Номера социального страхования`,
        "Historical passwords": `Старые пароли`,
      },
    },
    invoiceDetailsPage: {
        title: `Счет`,
        email: 'Электронная почта',
        customerNumber: 'Номер клиента',
        invoiceFrom: 'Счет от',
        invoiceTo: 'Счет для',
        invoiceDate: 'Дата счета',
        invoicePaymentMethod: 'Метод оплаты',
        invoiceDescription: 'Описание',
        invoiceProductQty: 'Кол-во',
        invoiceProductPrice: 'Цена',
        invoiceTotal: 'Итого',
        invoiceSubtotal: 'Подитог',
        invoiceVat: 'Налоги (НДС)',
        supportDescription: 'Есть вопрос?',
        status: {
            open: 'Открыто',
            paid: 'оплачено',
            canceled: 'отменено',
            pending: 'ожидается',
            chargeback: 'возврат',
            expired: 'истек',
            failed: 'неудачно',
            settled: 'урегулировано',
            partially_refunded: 'частично возвращено',
            refunded: 'возвращено',
            authorized: 'авторизовано',
            internal_error: 'внутренняя ошибка',
        }
    },
    maintenancePage: {

        h1: `Мы проводим техническое обслуживание.`,
        h2: `Скоро вернемся!`,
    },
    page404: {
        h1: `Упс… страница, которую вы ищете, не существует.`,
        p: `Заблудились во время поиска нидерландского VPN-провайдера? Не волнуйтесь, мы вас туда приведем!`,
        btn: `Приведите меня к лучшему VPN!`,
    }
};

export default ru;
